// export const API_URL = process.env.REACT_APP_API_URL // API URL
// export const CHART_HISTORY = process.env.REACT_APP_CHART_URL + '/history'
// export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL
// export const GLOBAL_URL = process.env.REACT_APP_GLOBAL_URL
// export const GOOGLE_CLIEND_ID = process.env.REACT_APP_GOOGLE_CLIEND_ID || ''
export const API_URL = import.meta.env.VITE_APP_API_URL // API URL
export const NEW_API_URL = import.meta.env.VITE_APP_NEW_API_URL // New JWT Auth API URL (Dual Token)
export const API_COIN_TIER = import.meta.env.VITE_APP_API_COIN_TIER
export const VITE_APP_API_MEDIA_DEV_URL = import.meta.env.VITE_APP_API_MEDIA_DEV_URL // API URL
export const VITE_APP_API_MEDIA_URL = import.meta.env.VITE_APP_API_MEDIA_URL // API URL
export const CHART_HISTORY = import.meta.env.VITE_APP_CHART_URL + '/history'
export const SOCKET_URL = import.meta.env.VITE_APP_SOCKET_URL
export const GLOBAL_URL = import.meta.env.VITE_APP_GLOBAL_URL
export const GOOGLE_CLIEND_ID = import.meta.env.VITE_APP_GOOGLE_CLIEND_ID || ''

export const USERINFO = '/user/my/info' // 사용자 정보
export const MYSETTINGS = '/user/my/settings' // 내 설정
export const MYBALANCE = '/user/my/balance' // 내 자산
export const POPUP = '/popup/active' // popup
export const MYTRADESETTINGS = '/user/my/tradesetting' // 내 트레이딩설정

export const TRANSFER = '/user/my/transfer'

export const EXCHANGESETTINGS = '/exchanges' // 거래쌍 설정
export const ORDERBOOK = '/trade/orderbooks' // 오더북
export const CANCELORDER = '/trade/cancel' // 주문취소

export const TRADELIST = '/trade/tradelist' // 주문취소

export const P2P_TRADES = '/p2p/trades' // P2P 거래 조회
export const P2P_ACCOUNT_TRADES = '/p2p/account/trades' // P2P 거래 조회

export const USER_KYC_LIST = '/kyc/list' // 사용자의 KYC 요청 목록 조회

export const REFERREL_USERS = '/referral/referred-users' // 레퍼럴 사용자 목록 조회 (일반)
export const REFERREL_FEE = '/referral/fee-history' // 레퍼럴 수수료 내역 조회


export const EVENTS = '/events' // 이벤트 목록 조회
export const MY_EVENTS = '/events/account/participations' // 이벤트 목록 조회

export const WITHDRAW = '/withdraw/addresses' // 이벤트 목록 조회



